export const companyScrapRulesDefaultColumns = [
  { label: 'Nome', value: 'display_name' },
  { label: 'Ações', value: 'action', className: 'w-9' },
];
